import React from 'react'

const Footer = () => {
    const year = new Date().getFullYear();
    return(
        <footer>
        <section >
         
           <h4> {` copyright © Chaitali Mahida ${year} `}</h4>
       
            </section>
            </footer>
    )
}
export default Footer